/* RECORDING THE VOICE (supabase/0030). One row every time Brill's words land
 * in her fields — the half of "learn from the difference" that was never kept.
 * Her finished copy is the record itself; see the migration for how a pair is
 * read back.
 *
 * THE RULE THIS FILE HOLDS: recording NEVER gets in her way. A Lock or a
 * sparkle that has already saved her words does not wait on this, and a failed
 * write does not surface as a save problem on a screen whose save worked. It
 * warns in the console and returns false, and `scripts/check-voice-drafts.js`
 * is how anyone finds out whether rows are arriving — the silent failure
 * CLAUDE.md warns about, answered by a script rather than by a banner that
 * would tell her about machinery she never asked for.
 *
 * COST: one small Supabase insert per Lock / sparkle / brainstorm fill. No
 * Brill call, nothing on render, nothing read back.
 */
import { useSupabase } from "../supabaseClient";

export const VOICE_HOW = ["lock", "sparkle", "brainstorm"];

const hasWords = (content) => Object.values(content || {}).some((v) =>
  Array.isArray(v) ? v.some((x) => (typeof x === "object" ? hasWords(x) : String(x || "").trim())) : String(v ?? "").trim());

/** The row, or null when there is nothing worth keeping. Pure, for tests. */
export function voiceDraftRow({ tool, recordType, recordId, blockId = null, how, draft, replaced = null }) {
  if (!tool || !recordType || !recordId || !VOICE_HOW.includes(how)) return null;
  if (!hasWords(draft)) return null;
  return {
    id: "vd_" + Math.random().toString(36).slice(2, 12),
    tool,
    record_type: recordType,
    record_id: String(recordId),
    block_id: blockId || null,
    how,
    draft,
    replaced: hasWords(replaced) ? replaced : null,
  };
}

/** `record(entry)` → Promise<boolean>. Fire it and move on. */
export function useVoiceRecorder() {
  const getSb = useSupabase();
  return async (entry) => {
    const row = voiceDraftRow(entry || {});
    if (!row) return false;
    try {
      const sb = await getSb();
      const { error } = await sb.from("voice_drafts").insert(row);
      if (error) {
        // eslint-disable-next-line no-console
        console.warn("voice_drafts: not recorded —", error.message || error);
        return false;
      }
      return true;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn("voice_drafts: not recorded —", err?.message || err);
      return false;
    }
  };
}
